module.exports = __webpack_public_path__ + "img/Children.8048f6bf.png";